(()=>{
  function buildItems(id,quantity,properties,addonId,enabled){
    if(!/^\d+$/.test(String(id))||!Number.isSafeInteger(quantity)||quantity<1)throw new Error('数量を1以上の整数で入力してください。');
    const items=[{id:String(id),quantity,properties}];
    if(enabled){
      if(!/^\d+$/.test(String(addonId)))throw new Error('オプションを確認できません。');
      items.push({id:String(addonId),quantity,parent_id:String(id)});
    }
    return items;
  }
  if(typeof module!=='undefined')module.exports={buildItems};
  if(typeof window==='undefined')return;
  if(customElements.get('layer-envelope-option'))return;
  customElements.define('layer-envelope-option',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;
      this.root=this.closest('section');
      this.addEventListener('change',()=>this.update());
      this.root.addEventListener('input',()=>this.update());
      this.root.addEventListener('change',()=>this.update());
      this.root.addEventListener('submit',event=>this.submit(event),true);
      this.update();
    }
    update(){
      this.enabled=this.querySelector('input[type=radio]:checked')?.value==='with';
      const quantity=Number(this.root.querySelector('[name=quantity]')?.value||1);
      this.querySelector('[data-envelope-property]').value=this.enabled?'あり（別売り）':'なし';
      const preview=this.querySelector('[data-envelope-preview]');if(preview)preview.hidden=!this.enabled;
      const total=this.querySelector('[data-envelope-total]');total.hidden=!this.enabled;
      const money=cents=>new Intl.NumberFormat('ja-JP').format(cents/100)+'円';
      const safeQuantity=Number.isSafeInteger(quantity)&&quantity>0?quantity:0;
      const fee=Number(this.dataset.unitPrice)*safeQuantity;
      total.textContent=`オプション ${safeQuantity}セット：＋${money(fee)} ／ 商品と合わせて ${money(Number(this.dataset.basePrice)*safeQuantity+fee)}（税込）`;
      this.querySelector('[data-envelope-error]').hidden=true;
    }
    async submit(event){
      if(event.target.getAttribute('id')!==this.dataset.formId||!this.enabled)return;
      event.preventDefault();event.stopImmediatePropagation();
      if(this.busy)return;
      const form=event.target,button=form.querySelector('[type=submit]'),error=this.querySelector('[data-envelope-error]');
      if(!form.reportValidity())return;
      try{
        const data=new FormData(form),properties={};
        for(const [key,value]of data){const match=key.match(/^properties\[(.+)\]$/);if(match)properties[match[1]]=value;}
        const items=buildItems(data.get('id'),Number(data.get('quantity')||1),properties,this.dataset.addonId,true);
        this.busy=true;button.disabled=true;button.setAttribute('aria-busy','true');
        const cart=document.querySelector('cart-drawer')||document.querySelector('cart-notification');
        const payload={items};
        if(cart){payload.sections=cart.getSectionsToRender().map(section=>section.id);payload.sections_url=window.location.pathname;cart.setActiveElement(document.activeElement);}
        const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
        const result=await response.json();
        if(!response.ok||result.status)throw new Error(result.description||'カートに追加できませんでした。');
        if(cart&&result.sections){
          cart.classList.remove('is-empty');
          try{cart.renderContents(result);}catch(renderError){window.location.assign(window.routes?.cart_url||'/cart');}
        }else{window.location.assign(window.routes?.cart_url||'/cart');}
      }catch(cause){error.textContent=cause.message||'通信に失敗しました。カートをご確認のうえ、もう一度お試しください。';error.hidden=false;}
      finally{this.busy=false;if(button){button.disabled=false;button.removeAttribute('aria-busy');}}
    }
  });
})();
